import React, { useEffect, useState } from "react"
import Sidebar from "../components/sidebar"
import Topbar from "../components/topbar"
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from "../axiosInstance";
import Pagination from "../components/Pagination";
import { errorMessage } from "../hooks/UserLogs";
export default function Agency() {
  const [view, setView] = useState(false);
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [ListAgencies, setListAgencies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [emailUp, setEmailUp] = useState("");
  const [nameUp, setNameup] = useState("");
  const [phoneUp, setPhoneUp] = useState("");
  const [codeUp, setCodeUp] = useState("");
  const [passwordUp, setPasswordUp] = useState("");
  const [errorForm, setErrorForm] = useState({});
  const [errMsg, seterrMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowErro] = useState(false);
  const [idUp, setIdUp] = useState('');
  let header =
  {
    'Content-Type': 'application/json'
  };
  const navigate = useNavigate();
  const handleClose = () => {
    setErrorForm({});
    setCodeUp("")
    setEmailUp("")
    setIdUp('');
    setPhoneUp("")
    setView(false)

  }
  const viewClose = () => {
    setEmailUp('');
    setPhoneUp('');
    setNameup('');
    setIdUp('');
    setView(false)
  }
  const viewUpdate = (name, email, phone, idAgency) => {
    setEmailUp(email);
    setPhoneUp(phone);
    setNameup(name);
    setIdUp(idAgency);
    setView(true);
  }
  const viewOpen = () => {
    setView(true)
  }
  const handleCloseError = () => {
    setShowErro(false);
  }


  const bUrl = process.env.REACT_APP_B_URL;
  const { id } = useParams();
  const getListAgencies = async (email, phone, code) => {
    let ulr = "/agencies?page=" + currentPage + "&limit=10";
    setCode(code);
    setEmail(email);
    setPhone(phone);
    if (code != '' | phone != '' | email != '') {
      ulr = "/agencies/searche?page=" + currentPage + "&limit=10";
      if (email != '') {
        ulr += "&email=" + email;
      }
      if (code != '') {
        ulr += "&code=" + code;
      }
      if (phone != '') {
        ulr += "&phone=" + phone;
      }
      console.log(ulr)
    }
    const response = await axios.get(bUrl + ulr).catch((err) => {
      console.log(err);
      setIsLoading(false)

    });
    if (response) {
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        seterrMsg(msg);
        setShowErro(true);
      } else {
      setListAgencies(response.data.body);
      setTotalPage(response.data.totalPage);
      }

      setIsLoading(false);
    }
  }
  const postCutomers = async () => {

  }
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  const addForm = () => {
    let error = {};
    let isvalid = true;
    if (emailUp == "") {
      error.emailUp = "Field is required!";
      isvalid = false;
    }
    if (nameUp == "") {
      error.nameUp = "Field is required!";
      isvalid = false;
    }

    if (phoneUp == "") {
      error.phoneUp = "Field is required!";
      isvalid = false;
    }

    setErrorForm(error);
    if (isvalid) {
      setIsLoading(true);
      axios.post(bUrl + "/agency",

        //birthDay: birthDay,
        {
          name: nameUp,
          "email": emailUp,
          "phone": phoneUp,
          "fkIdStaff": sessionStorage.getItem("idUser")
        }


        , { header: header })
        .then(function (response) {
          //getDayOffDayEmmp(idEmp);
          setIsLoading(false)

          handleClose()
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            seterrMsg(msg);
            setShowErro(true);
          } else {
            getListAgencies(email, phone, code);
          }

        })
        .catch(function (error) {
          setIsLoading(false)

          setShowErro(true);
        });
    }
  }
  const updateForm = () => {
    let error = {};
    let isvalid = true;
    if (emailUp == "") {
      error.emailUp = "Field is required!";
      isvalid = false;
    }
    if (nameUp == "") {
      error.nameUp = "Field is required!";
      isvalid = false;
    }

    if (phoneUp == "") {
      error.phoneUp = "Field is required!";
      isvalid = false;
    }

    setErrorForm(error);
    if (isvalid) {
      setIsLoading(true);
      axios.put(bUrl + "/agency?idAgency=" + idUp,

        //birthDay: birthDay,
        {
          name: nameUp,
          "email": emailUp,
          "phone": phoneUp,
          "fkIdStaff": sessionStorage.getItem("idUser")
        }


        , { header: header })
        .then(function (response) {
          //getDayOffDayEmmp(idEmp);
          setIsLoading(false)

          handleClose()
          if (response?.data?.isError) {
            const msg = errorMessage(response?.data?.code)
            seterrMsg(msg);
            setShowErro(true);
          } else {
            getListAgencies(email, phone, code);
          }

        })
        .catch(function (error) {
          setIsLoading(false)

          console.log(error);
          setShowErro(true);
        });
    }
  }
  useEffect(() => {
    if (sessionStorage.getItem("aname") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }

    getListAgencies(email, phone, code);
  }, [currentPage])

  return (
    <div className="App list-page agency-page">
      <div className="">


        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">

              <div className="table-content mt-2 p-2 text d-flex justify-content-between align-items-start">
                <div className="list-page-header"><div className='fw-bold'>Agence</div></div>
                <Topbar />
              </div>



              <div className="list-filter-card mt-3">
                <div className="list-filter-toolbar">
                  <div className="list-filter-fields">
                    <div className="list-field">
                      <label htmlFor="exampleInputEmail1">Email</label>
                      <input type="email" onChange={(e) => getListAgencies(e.target.value, phone, code)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
                    </div>
                    <div className="list-field">
                      <label htmlFor="phone">Phone</label>
                      <input type="text" onChange={(e) => getListAgencies(email, e.target.value, code)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                    </div>
                    <div className="list-field">
                      <label htmlFor="code">Code</label>
                      <input type="text" onChange={(e) => getListAgencies(email, phone, e.target.value)} className="form-control" id="code" aria-describedby="Phone" placeholder="Code" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="list-table-wrap mt-3 p-3">


                <button onClick={() => viewOpen()}>

                  <i className='bx bxs-plus-circle icon'></i>
                </button>
                {/* <a href="/Home/Create" className="btn btn-primary mb-1"> </a> */}
                <div className="table-responsive">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table list-table text mb-0">
                      <thead>
                        <tr>

                          <th scope="col">Id</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Code</th>
                          <th scope="col">Téléphone</th>
                          <th scope="col">Email</th>
                          <th scope="col">Date</th>
                          <th>Action</th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListAgencies.length > 0 ? ListAgencies.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            <td>{a.name}</td>
                            <td>{a.code}</td>

                            <td>{a.phone}</td>
                            <td>{a.email}</td>

                            <td>{formatDate(a.createdDate)}</td>
                            <td>
                              <div className="list-table-actions">
                                <Link to={"/agencies/" + a.idAgency}><i className='bx bx-notepad' title="Détails"></i></Link>
                                <Link to={"/accountingOpByCustomer/" + a.fkIdAccounting}><i className='bx bx-folder-open' title="Opérations"></i></Link>
                                <i onClick={() => viewUpdate(a.name, a.email, a.phone, a.idAgency)} className='bx bx-edit-alt colore-icon' title="Update"></i>
                                <Link to={"/agents?idAgency=" + a.idAgency}><i className='bx bxs-user-badge' title="Marchands"></i></Link>
                                <Link to={"/agencyUserOfAgency/" + a.idAgency}><i className='bx bxs-group' title="Utilisateurs"></i></Link>
                              </div>
                            </td>

                          </tr>
                        }) : <tr></tr>}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />
              </div>

            </div>
          </div>
        </section>
      </div>
      <Modal show={view} onHide={viewClose} className="">
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Agency</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group mb-2">
              <input type="text" placeholder="Name" name="name" className='form-control ' value={nameUp} onChange={(e) => setNameup(e.target.value)} />
              {errorForm.nameUp != "" && <p style={{ color: 'red' }}>{errorForm.nameUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Email" name="name" className='form-control ' value={emailUp} onChange={(e) => setEmailUp(e.target.value)} />
              {errorForm.emailUp != "" && <p style={{ color: 'red' }}>{errorForm.emailUp}</p>}
            </div>
            <div className="form-group mb-2">
              <input type="text" placeholder="Phone" name="name" className='form-control ' value={phoneUp} onChange={(e) => setPhoneUp(e.target.value)} />
              {errorForm.phoneUp != "" && <p style={{ color: 'red' }}>{errorForm.phoneUp}</p>}
            </div>





          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={viewClose}>
            Close
          </Button>
          {idUp === '' ?
            isLoading ?
              <img src='../Custom.svg' width="3%" />
              :
              <Button variant="primary" onClick={addForm}>
                Ajouter
              </Button>
            :
            <Button variant="primary" onClick={updateForm}>
              Modifier
            </Button>
          }
        </Modal.Footer>
      </Modal>

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
